var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpinToWinPeg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 41 39"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#SpinToWinPeg_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#SpinToWinPeg_svg__b)",
  d: "M23.155 28.953c-1.125 2.137-4.186 2.137-5.31 0L5.059 4.647C4.01 2.649 5.457.25 7.714.25h25.572c2.257 0 3.706 2.399 2.655 4.397z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "SpinToWinPeg_svg__b",
  x1: 20.5,
  x2: 20.5,
  y1: -11,
  y2: 34,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF9873"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF6731"
})), /*#__PURE__*/React.createElement("filter", {
  id: "SpinToWinPeg_svg__a",
  width: 39.578,
  height: 38.305,
  x: 0.711,
  y: 0.25,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_40001596_13710"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_40001596_13710",
  result: "shape"
})))));
export default SvgSpinToWinPeg;